import React from 'react';
import styled, { css } from 'styled-components';

import { useSollersHomeData } from '@/modules/SollersHome/hooks';
import { ContentContainer } from '@/modules/SollersHome/common.styles';
import { media } from '@/utils/mixin';
import { DealerMap } from '@/components/LandingWidgets';

function Map() {
  const { mapType, mapImage, mapMobileImage, mapItems } = useSollersHomeData();

  if (!mapItems || mapItems.length === 0) {
    return null;
  }

  return (
    <Component>
      <ContentContainer>
        <DealerMap
          mapType={mapType ?? 'google'}
          dealers={mapItems.map(
            ({
              mapName,
              mapLegalName,
              mapAddress,
              mapServices,
              mapPhones,
              mapFacebook,
              mapVk,
              mapInstagram,
              mapTelegram,
              mapViber,
              mapSkype,
              mapOk,
              mapYoutube,
              mapLatitude,
              mapLongitude,
            }) => ({
              name: mapName ?? '',
              legalName: mapLegalName ?? '',
              address: mapAddress ?? '',
              services:
                mapServices && mapServices.length !== 0
                  ? mapServices.map(({ name }) => name ?? '')
                  : [],
              phones:
                mapPhones && mapPhones.length !== 0
                  ? mapPhones.map(({ phone }) => phone ?? '')
                  : [],
              socials: {
                facebook: mapFacebook ?? '',
                vk: mapVk ?? '',
                instagram: mapInstagram ?? '',
                telegram: mapTelegram ?? '',
                viber: mapViber ?? '',
                skype: mapSkype ?? '',
                ok: mapOk ?? '',
                youtube: mapYoutube ?? '',
              },
              latitude: Number(mapLatitude),
              longitude: Number(mapLongitude),
            })
          )}
          mapImages={{ desktop: mapImage, mobile: mapMobileImage }}
        />
      </ContentContainer>
    </Component>
  );
}

export default Map;

const Component = styled.section`
  padding: 30px 0 60px;

  ${media.tablet(css`
    padding: 20px 0 40px;
  `)}
`;
